import React, { useState } from "react";
import { Modal } from "react-bootstrap";

const VariantsModal = ({ show, onHide, product, onStockChange, isReadOnly }) => {
  const [searchQuery, setSearchQuery] = useState("");

  if (!product) return null;

  const filteredVariants = (product.variants || []).filter((v) =>
    (v.size || "").toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="custom-modal-width"
      contentClassName="premium-modal-content"
      style={{ backdropFilter: "blur(4px)" }}
    >
      <Modal.Header
        style={{
          borderBottom: "1px solid #f1f5f9",
          padding: "20px 24px",
          background: "#fff",
          borderRadius: "16px 16px 0 0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <Modal.Title
            style={{
              fontSize: "20px",
              fontWeight: "700",
              color: "#0f172a",
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <i className="fa fa-cubes" style={{ color: "#3b82f6" }}></i>
            Manage Variants & Stock
          </Modal.Title>
          <p style={{ margin: "4px 0 0 0", fontSize: "13px", color: "#64748b" }}>
            Adjust stock settings for <strong>{product.name}</strong>
          </p>
        </div>
        <button
          onClick={onHide}
          style={{
            border: "none",
            background: "#f1f5f9",
            borderRadius: "50%",
            width: "36px",
            height: "36px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            color: "#64748b",
            fontSize: "16px",
            transition: "all 0.15s",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#e2e8f0";
            e.currentTarget.style.color = "#0f172a";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#f1f5f9";
            e.currentTarget.style.color = "#64748b";
          }}
        >
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>

      <Modal.Body style={{ padding: "24px", background: "#f8fafc" }}>
        {/* Product Details Summary Card */}
        <div
          style={{
            backgroundColor: "#fff",
            border: "1px solid #e2e8f0",
            borderRadius: "12px",
            padding: "16px",
            marginBottom: "20px",
            display: "flex",
            alignItems: "flex-start",
            gap: "16px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.01)",
          }}
        >
          <div
            style={{
              width: "60px",
              height: "60px",
              borderRadius: "10px",
              backgroundColor: "#f1f5f9",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "700",
              color: "#475569",
              fontSize: "16px",
              overflow: "hidden",
              flexShrink: 0,
            }}
          >
            {product.image ? (
              <img src={product.image} style={{ width: "100%", height: "100%", objectFit: "cover" }} alt={product.name} />
            ) : (
              (product.name || "IT").substring(0, 2).toUpperCase()
            )}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
              <h4 style={{ margin: "0", fontSize: "16px", fontWeight: "600", color: "#0f172a" }}>
                {product.name}
              </h4>
              {product.productNumber && (
                <span style={{ fontSize: "11px", color: "#64748b", backgroundColor: "#f1f5f9", padding: "2px 6px", borderRadius: "4px", fontWeight: "600" }}>
                  #{product.productNumber}
                </span>
              )}
              {product.type && (
                <span
                  style={{
                    fontSize: "10px",
                    fontWeight: "700",
                    color: product.type.toLowerCase() === "veg" ? "#16a34a" : "#dc2626",
                    border: `1.5px solid ${product.type.toLowerCase() === "veg" ? "#bbf7d0" : "#fecaca"}`,
                    backgroundColor: product.type.toLowerCase() === "veg" ? "#f0fdf4" : "#fef2f2",
                    padding: "1px 6px",
                    borderRadius: "4px",
                  }}
                >
                  {product.type}
                </span>
              )}
            </div>
            
            <div style={{ fontSize: "13px", color: "#64748b", display: "flex", gap: "8px", alignItems: "center", marginTop: "4.5px" }}>
              <span>{product.category}</span>
              <span>·</span>
              <span style={{ fontSize: "12px", fontWeight: "700", color: "#3b82f6", backgroundColor: "#eff6ff", padding: "2px 8px", borderRadius: "6px", border: "1px solid #bfdbfe" }}>
                SAR {product.price}
              </span>
            </div>

            {product.description && (
              <p style={{ margin: "6px 0 0 0", fontSize: "13px", color: "#64748b", fontStyle: "italic" }}>
                {product.description}
              </p>
            )}

            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "8px" }}>
              {product.addOns && product.addOns.length > 0 && (
                <div
                  style={{
                    backgroundColor: "#eff6ff",
                    borderRadius: "20px",
                    padding: "2px 10px",
                    fontSize: "11px",
                    color: "#1e40af",
                    border: "1px solid #bfdbfe",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "4px",
                    fontWeight: "500",
                  }}
                >
                  <strong>Add-ons:</strong> {product.addOns.map(a => `${a.name} (+SAR ${a.charges})`).join(", ")}
                </div>
              )}
              {product.choices && product.choices.length > 0 && (
                <div
                  style={{
                    backgroundColor: "#faf5ff",
                    borderRadius: "20px",
                    padding: "2px 10px",
                    fontSize: "11px",
                    color: "#6b21a8",
                    border: "1px solid #e9d5ff",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "4px",
                    fontWeight: "500",
                  }}
                >
                  <strong>Choices:</strong> {product.choices.map(c => `${c.name} (+SAR ${c.charges})`).join(", ")}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Search bar inside Modal */}
        <div style={{ marginBottom: "20px" }}>
          <div style={{ position: "relative" }}>
            <i
              className="fa fa-search"
              style={{
                position: "absolute",
                left: "14px",
                top: "14px",
                color: "#94a3b8",
                fontSize: "14px",
              }}
            ></i>
            <input
              type="text"
              placeholder="Search variants by size name..."
              className="form-control"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{
                paddingLeft: "40px",
                height: "42px",
                borderRadius: "10px",
                border: "1px solid #e2e8f0",
                fontSize: "14px",
                boxShadow: "none",
              }}
            />
          </div>
        </div>

        {/* Variants list */}
        {filteredVariants.length > 0 ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              maxHeight: "400px",
              overflowY: "auto",
              paddingRight: "4px",
            }}
          >
            {filteredVariants.map((v, i) => {
              const isUnlimited = v.branchStock ? v.branchStock.isUnlimited : true;
              const stockCount = v.branchStock ? v.branchStock.stock : 0;
              const sizeInitial = v.size ? v.size.charAt(0).toUpperCase() : "V";

              return (
                <div
                  key={v._id || i}
                  style={{
                    backgroundColor: "#fff",
                    border: "1px solid #e2e8f0",
                    borderRadius: "12px",
                    padding: "16px 20px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    boxShadow: "0 1px 3px rgba(15, 23, 42, 0.03)",
                    transition: "border-color 0.2s, box-shadow 0.2s",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = "#cbd5e1";
                    e.currentTarget.style.boxShadow = "0 4px 6px rgba(15, 23, 42, 0.05)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = "#e2e8f0";
                    e.currentTarget.style.boxShadow = "0 1px 3px rgba(15, 23, 42, 0.03)";
                  }}
                >
                  {/* Left: Info */}
                  <div style={{ display: "flex", alignItems: "flex-start", gap: "14px", flex: 1, marginRight: "16px", minWidth: 0 }}>
                    <div
                      style={{
                        width: "40px",
                        height: "40px",
                        minWidth: "40px",
                        maxWidth: "40px",
                        minHeight: "40px",
                        maxHeight: "40px",
                        flex: "0 0 40px",
                        borderRadius: "8px",
                        backgroundColor: v.default ? "#e0f2fe" : "#f1f5f9",
                        color: v.default ? "#0284c7" : "#475569",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontWeight: "700",
                        fontSize: "14px",
                        border: v.default ? "1px solid #bae6fd" : "1px solid #e2e8f0",
                      }}
                    >
                      {sizeInitial}
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <span style={{ fontSize: "15px", fontWeight: "600", color: "#0f172a" }}>
                          {v.size || "Standard"}
                        </span>
                        {v.default && (
                          <span
                            style={{
                              fontSize: "9px",
                              fontWeight: "700",
                              backgroundColor: "#f0fdf4",
                              color: "#16a34a",
                              border: "1px solid #bbf7d0",
                              padding: "1px 6px",
                              borderRadius: "12px",
                              textTransform: "uppercase",
                            }}
                          >
                            Default Choice
                          </span>
                        )}
                      </div>
                      <div style={{ marginTop: "6px", display: "flex", alignItems: "center", gap: "8px" }}>
                        {v.discountedPrice > 0 ? (
                          <>
                            <span style={{ fontSize: "12px", fontWeight: "700", color: "#dc2626", backgroundColor: "#fef2f2", padding: "2px 8px", borderRadius: "6px", border: "1px solid #fecaca" }}>
                              SAR {v.discountedPrice}
                            </span>
                            <span style={{ textDecoration: "line-through", color: "#94a3b8", fontSize: "11px", fontWeight: "500" }}>
                              SAR {v.price}
                            </span>
                          </>
                        ) : (
                          <span style={{ fontSize: "12px", fontWeight: "700", color: "#3b82f6", backgroundColor: "#eff6ff", padding: "2px 8px", borderRadius: "6px", border: "1px solid #bfdbfe" }}>
                            SAR {v.price}
                          </span>
                        )}
                      </div>
                      {v.desc && (
                        <p style={{ margin: "6px 0 0 0", fontSize: "12.5px", color: "#64748b", lineHeight: "1.5", fontStyle: "italic" }}>
                          {v.desc}
                        </p>
                      )}
                      <div style={{ marginTop: "4px", fontSize: "11px", color: "#94a3b8", display: "flex", gap: "8px", flexWrap: "wrap" }}>
                        <span>HO Stock: {v.stock}</span>
                        <span>·</span>
                        <span>HO Status: {v.status || "Active"}</span>
                      </div>
                    </div>
                  </div>

                  {/* Right: Stock Controls */}
                  <div style={{ marginTop: "2px", flexShrink: 0, marginLeft: "16px" }}>
                    {isUnlimited ? (
                      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: "600",
                            backgroundColor: "#ecfdf5",
                            color: "#059669",
                            padding: "4px 10px",
                            borderRadius: "6px",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                          }}
                        >
                          <span style={{ width: "6px", height: "6px", borderRadius: "50%", backgroundColor: "#059669" }}></span>
                          Unlimited Stock
                        </span>
                        {!isReadOnly && (
                          <button
                            onClick={() => onStockChange(product.id, v._id || v.variantId, "set", 10)}
                            style={{
                              border: "1px solid #e2e8f0",
                              background: "#fff",
                              borderRadius: "8px",
                              padding: "6px 12px",
                              fontSize: "12px",
                              fontWeight: "600",
                              color: "#475569",
                              cursor: "pointer",
                              transition: "all 0.15s",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = "#f8fafc";
                              e.currentTarget.style.borderColor = "#cbd5e1";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = "#fff";
                              e.currentTarget.style.borderColor = "#e2e8f0";
                            }}
                          >
                            Set Limit
                          </button>
                        )}
                      </div>
                    ) : (
                      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid #cbd5e1",
                            borderRadius: "8px",
                            overflow: "hidden",
                            backgroundColor: "#f8fafc",
                          }}
                        >
                          {!isReadOnly && (
                            <button
                              onClick={() => onStockChange(product.id, v._id || v.variantId, "decrement")}
                              style={{
                                border: "none",
                                background: "transparent",
                                width: "28px",
                                height: "28px",
                                cursor: "pointer",
                                color: "#64748b",
                                fontWeight: "700",
                                fontSize: "13px",
                              }}
                            >
                              -
                            </button>
                          )}
                          <span
                            style={{
                              width: "32px",
                              textAlign: "center",
                              fontSize: "13px",
                              fontWeight: "700",
                              color: "#0f172a",
                            }}
                          >
                            {stockCount}
                          </span>
                          {!isReadOnly && (
                            <button
                              onClick={() => onStockChange(product.id, v._id || v.variantId, "increment")}
                              style={{
                                border: "none",
                                background: "transparent",
                                width: "28px",
                                height: "28px",
                                cursor: "pointer",
                                color: "#64748b",
                                fontWeight: "700",
                                fontSize: "13px",
                              }}
                            >
                              +
                            </button>
                          )}
                        </div>
                        {!isReadOnly && (
                          <button
                            onClick={() => onStockChange(product.id, v._id || v.variantId, "set", null)}
                            style={{
                              border: "none",
                              background: "none",
                              color: "#ef4444",
                              fontSize: "12px",
                              fontWeight: "600",
                              cursor: "pointer",
                              padding: "0",
                              textDecoration: "underline",
                            }}
                          >
                            Remove Limit
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div
            style={{
              textAlign: "center",
              padding: "40px 20px",
              backgroundColor: "#fff",
              borderRadius: "12px",
              border: "1px dashed #cbd5e1",
              color: "#64748b",
            }}
          >
            <i
              className="fa fa-info-circle"
              style={{ fontSize: "24px", color: "#94a3b8", marginBottom: "8px" }}
            ></i>
            <div>No variants match your query.</div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default VariantsModal;
